import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Select} from "antd";

/**
 * creat by xcc
 * @description 模式选择
 */
export default class ModeSelect extends Component {
    static propTypes = {
        onClick: PropTypes.func,
    };
    static defaultProps = {
        onClick: () => {
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            value: "card"
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    getData() {
        return ([
            {
                key: "card",
                dec: "大图模式"
            },
            {
                key: "list",
                dec: "列表模式",
            },
        ])
    }

    render() {
        const dataSource = this.getData();
        const {styleOut, onClick} = this.props;
        return (
            <div style={styleOut}>
                <Select placeholder={"请选择"} style={{width: 100}} value={this.state.value} onChange={(value) => {
                    this.setState({
                        value
                    })
                }}>
                    {dataSource.map(item => {
                        return (
                            <Select.Option key={item.key} value={item.key}
                                           onClick={() => onClick(item)}>{item.dec}</Select.Option>
                        )
                    })}
                </Select>
            </div>
        )
    }
}